export default __webpack_public_path__ + "static/media/fawry.9022e492.png";